/* @flow */

export const LOG_LEVEL = {
    DEBUG: ('debug' : 'debug'),
    INFO:  ('info' : 'info'),
    WARN:  ('warn' : 'warn'),
    ERROR: ('error' : 'error')
};

export const PROTOCOL = {
    FILE: 'file:'
};
